import { render, staticRenderFns } from "./Editor-Checkbox.vue?vue&type=template&id=4aa3d9b3&scoped=true"
import script from "./Editor-Checkbox.vue?vue&type=script&lang=ts"
export * from "./Editor-Checkbox.vue?vue&type=script&lang=ts"
import style0 from "./Editor-Checkbox.vue?vue&type=style&index=0&id=4aa3d9b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3d9b3",
  null
  
)

export default component.exports